import { render, staticRenderFns } from "./QuestionForm.vue?vue&type=template&id=19e438a1&scoped=true"
import script from "./QuestionForm.vue?vue&type=script&lang=js"
export * from "./QuestionForm.vue?vue&type=script&lang=js"
import style0 from "./QuestionForm.vue?vue&type=style&index=0&id=19e438a1&prod&lang=scss&scoped=true"
import style1 from "./QuestionForm.vue?vue&type=style&index=1&id=19e438a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e438a1",
  null
  
)

export default component.exports